import { toast } from "react-toastify";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../config/axiosInterceptor";

function EditWorkflowUser() {
    const navigate = useNavigate();
    const location = useLocation();
    const baseUrl = process.env.REACT_APP_BASEURL1;

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        number: "",
        bio: "",
        password: "",
        access: "0"
    });

    const id = new URLSearchParams(location.search).get("id");

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await axiosInstance.get(`${baseUrl}/admin/workflowUser/getOne?id=${id}`);
                if (response.data.success) {
                    const { name, email, number, bio, access } = response.data.data;
                    setFormData({ name, email, number, bio, access: access.toString(), password: "" });
                } else {
                    toast.error(response.data.message);
                }
            } catch (error) {
                toast.error(error.message);
            }
        };

        if (id) {
            fetchUser();
        }
    }, [id, baseUrl]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "access" && value === "1") {
            alert("You are giving master access.");
        }
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const submissionData = { ...formData };
            if (!submissionData.password) {
                delete submissionData.password;
            }

            const response = await axiosInstance.put(`${baseUrl}/admin/workflowUser/updateWorkflowUser?id=${id}`, submissionData);
            if (response.data.success) {
                toast.success(response.data.message);
                navigate("/admin/manageWorkflowUser");
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error(error.message);
        }
    };

    return (
        <>
            <section className="content-header">
                <h1>Edit Workflow User</h1>
                <ol className="breadcrumb">
                    <li>
                        <Link to="/admin">
                            <i className="fa fa-dashboard"></i> Home
                        </Link>
                    </li>
                    <li>
                        <Link to="/admin/manageWorkflowUser">Manage Workflow User</Link>
                    </li>
                    <li className="active">Edit Workflow User</li>
                </ol>
            </section>
            <section className="content">
                <div className="row">
                    <div className="col-md-10">
                        <form onSubmit={handleSubmit}>
                            <div className="box box-warning">
                                <div className="box-header with-border">
                                    <h3 className="box-title">Edit User</h3>
                                </div>
                                <div className="box-body">
                                    <div className="form-group">
                                        <label>Name*</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="name"
                                            placeholder="Name"
                                            value={formData.name}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Email*</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            name="email"
                                            placeholder="Email"
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Mobile*</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="number"
                                            placeholder="Mobile"
                                            value={formData.number}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Bio*</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="bio"
                                            placeholder="Bio"
                                            value={formData.bio}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>New Password</label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            name="password"
                                            placeholder="Leave blank to keep current password"
                                            value={formData.password}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Access Level*</label>
                                        <select
                                            name="access"
                                            className="form-control"
                                            value={formData.access}
                                            onChange={handleChange}
                                        >
                                            <option value="0">Standard User (No Add, Edit, Delete)</option>
                                            <option value="1">Master Access</option>
                                            <option value="2">Limited Master Access</option>
                                        </select>
                                        <p className="help-block">
                                            0: No special permissions. <br />
                                            1: Full master access. <br />
                                            2: Master access with some limitations.
                                        </p>
                                    </div>
                                    <div className="form-group">
                                        <button type="button" className="btn btn-danger" onClick={() => navigate("/admin/manageWorkflowUser")}>
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-success pull-right"
                                        >
                                            Update
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </>
    );
}

export default EditWorkflowUser;